import gettext from "../shared/utils/gettext";

export const MEASUREMENTS_META = {
  recs: {
    unit: "0-1",
    yaxis: "records",
    stroke: "#00a600",
    domain: [0, 1],
  },
  ndvi: {
    unit: "-1-1",
    yaxis: "ndvi",
    stroke: "#00a600",
    domain: [-1, 1],
  },
  benchmark: {
    unit: "0-1",
    yaxis: "ndvi",
    stroke: "none",
    fill: "#c2eacd",
    domain: [0, 1],
  },
  air_temperature: {
    unit: "°C",
    yaxis: "temp",
    stroke: "#DC5E37",
    domain: [0, 40],
    clip: true,
  },
  precipitation: {
    unit: "mm",
    yaxis: "precip",
    stroke: "#2CA9D3",
    domain: [0, 20],
  },
  precipitation_deficit: {
    unit: `${gettext("deficit")} mm`,
    yaxis: "percent",
    stroke: "#882995",
    domain: [0, (datamax) => Math.round(datamax) + 20],
    clip: true,
  },
  soil_temperature: {
    unit: "°C",
    yaxis: "temp",
    stroke: "#623100",
    domain: [0, 40],
    clip: true,
  },
};
